var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "q-body-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-grey-10 no-underline",
                  attrs: {
                    to: {
                      name: "expenses-dashboard",
                      params: { teamId: _vm.activeTeam.id }
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tc("expense", 2)) + "\n      "
                  )
                ]
              ),
              _vm._v(" / "),
              _c("span", { staticClass: "text-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("overview")))
              ])
            ],
            1
          ),
          _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  _vm.$router.push({ name: "capture-expenses" })
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("capture_x_expenses_btn", {
                      count: _vm.notCapturedExpenses.value
                    })
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "layout-padding" }, [
        _c("div", { staticClass: "row gutter-md" }, [
          _c(
            "div",
            { staticClass: "col-12 col-xl-5" },
            [
              _c("expense-upload", {
                staticClass: "full-height",
                attrs: { uploadFunction: _vm.expenseUploadFunction },
                on: { uploaded: _vm.handleExpensesUploaded }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-xl-7" },
            [
              _c(
                "q-card",
                { staticClass: "bg-white full-height" },
                [
                  _c(
                    "q-card-main",
                    { staticClass: "q-py-xl" },
                    [
                      _vm.expensesStatistics
                        ? _c("bar", {
                            staticStyle: { height: "250px" },
                            attrs: {
                              chartdata: _vm.expensesChartdata,
                              options: _vm.expensesChartOptions
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "row justify-between items-end q-mb-md q-mt-lg" },
          [
            _c("span", { staticClass: "q-title text-bold text-blue-grey-4" }, [
              _vm._v(_vm._s(_vm.$t("uncaptured_expenses_heading")))
            ]),
            _c(
              "router-link",
              {
                staticClass: "router-link q-subheading text-blue-grey-4",
                attrs: { to: { name: "capture-expenses" } }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("capture_x_expenses_btn", { count: "" })) +
                    "\n      "
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row gutter-md" },
          [
            _vm._l(_vm.uncapturedExpenses, function(expense) {
              return _c(
                "div",
                { key: expense.id, staticClass: "col-auto" },
                [
                  _c(
                    "q-card-media",
                    {
                      staticStyle: { "max-height": "250px" },
                      nativeOn: {
                        click: function($event) {
                          _vm.$router.push({
                            name: "expense",
                            params: {
                              teamId: _vm.activeTeam.id,
                              expenseId: expense.id
                            }
                          })
                        }
                      }
                    },
                    [
                      _c("expense-preview", {
                        staticClass: "cursor-pointer",
                        attrs: { model: expense, width: "200" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm.uncapturedExpenses && _vm.uncapturedExpenses.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "column justify-center text-center full-width q-ma-lg q-mt-xl"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("assets/emptystates/expenses_empty.svg"),
                        height: "100px"
                      }
                    }),
                    _c("p", { staticClass: "q-mt-md text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("all_expenes_captured")))
                    ])
                  ]
                )
              : _vm._e()
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "row justify-between items-end q-mb-md q-mt-lg" },
          [
            _c("span", { staticClass: "q-title text-bold text-blue-grey-4" }, [
              _vm._v(_vm._s(_vm.$t("recent_expenses_heading")))
            ]),
            _c(
              "router-link",
              {
                staticClass: "router-link q-subheading text-blue-grey-4",
                attrs: {
                  to: {
                    name: "expenses-list",
                    params: { teamId: _vm.activeTeam.id }
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("view_all")) + "\n      ")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("expense-list", {
              attrs: { expenses: _vm.expenses },
              on: { "deleted-expense": _vm.handleExpenseDeleted }
            }),
            _vm.expenses && _vm.expenses.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "column justify-center text-center full-width q-ma-lg q-mt-xl"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("assets/emptystates/expenses_empty.svg"),
                        height: "100px"
                      }
                    }),
                    _c("p", { staticClass: "q-mt-md text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("no_recent_expenses_available")))
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }